import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';
import { connect } from 'react-redux';

import {
  patchMusicLink,
  clearMusicLinkPatchStatus,
} from 'redux/music-links/actions';

import MusicField from 'components/dashboard/music-links-content/MusicField';

import './MusicLinkName.css';


class MusicLinkName extends Component {
  static propTypes = {
    musicLinkId: PropTypes.number,
    musicLinkName: PropTypes.string,
    patchMusicLink: PropTypes.func,
  clearMusicLinkPatchStatus: PropTypes.func,
  };
  static defaultProps = {
    musicLinkId: null,
    musicLinkName: null,
    patchMusicLink: null,
    clearMusicLinkPatchStatus: null,
  };

  state = {
    currentValue: this.props.musicLinkName || null,
  };

  handleInputSubmit = (id, value) => {
    this.setState({ currentValue: value });

    if (value !== '') {
      this.props.patchMusicLink(id, { link_name: value });
    }
  };

  render() {
    const { musicLinkId, musicLinkName } = this.props;
    const { currentValue } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="music-link-name__component">
            <MusicField
              className="music-link-name-input"
              id={musicLinkId}
              value={musicLinkName}
              handleSubmit={this.handleInputSubmit}
              error={currentValue === '' ? { id: `music_link_name_id_${musicLinkId}`, text: t("Title cannot be empty") } : null}
            />
            <div className="subtext">{t("Title")}</div>
          </div>
        )}
      </Translation>
    );
  }
}

export default connect(
  null,
  {
    patchMusicLink,
    clearMusicLinkPatchStatus,
  },
)(MusicLinkName);
